import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const openWidget = () => {
    const el = $('.tolstoy-carousel-tile-container button.tolstoy-play-button-container').el()
    const event = new Event('click', { bubbles: true })
    el.dispatchEvent(event)
    if (window?.gtag) {
      window.gtag('event', 'See It In Action Click', {
        event_detail: 'Tolstoy Widget Opened',
      })
    }
  }

  $(node).on('click', openWidget)

  return () => {
    $(node).off('click', openWidget)
  }
})
